import React from 'react'
import { Link } from 'gatsby'
import styled from 'styled-components'
import {
  calculateResponsiveSize,
  calculateMobileResponsiveSize,
  mediaMax,
} from 'styles/media-queries'
import CloseIcon from 'icons/close.svg'
import HeaderLogo from 'icons/logo-mini.svg'
import ArrowIcon from 'icons/arrow.svg'
import ArrowWIcon from 'icons/arrow-w.svg'

import InstaIcon from 'icons/insta.svg'

export const Logo = styled((props) => <Link {...props} />)`
  width: ${calculateResponsiveSize(117)};
  height: ${calculateResponsiveSize(25)};
  background: url(${HeaderLogo}) no-repeat;
  background-size: contain;

  display: flex;

  ${mediaMax('mobile')} {
    width: ${calculateMobileResponsiveSize(80.66)};
    height: ${calculateMobileResponsiveSize(17.18)};
  }
`

export const MenuWrap = styled.div`
  color: #581f0c80;

  width: 100%;

  z-index: 20;
  padding: ${calculateResponsiveSize(7)} ${calculateResponsiveSize(20)}
    ${calculateResponsiveSize(24)} ${calculateResponsiveSize(20)};

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  height: 100%;
  transition: 0.7s 0s;

  opacity: 0;

  .open-menu & {
    opacity: 1;
    transition: 0.7s 0.7s;
  }

  ${mediaMax('mobile')} {
    padding: ${calculateMobileResponsiveSize(10)}
      ${calculateMobileResponsiveSize(20)} ${calculateMobileResponsiveSize(54)}
      ${calculateMobileResponsiveSize(20)};
  }
`

export const Item = styled((props) => <Link {...props} />)`
  color: #581f0c80;
  font-family: 'IvyMode';
  font-weight: 400;
  font-size: ${calculateResponsiveSize(42)};
  line-height: 130%;
  letter-spacing: 0.01em;
  text-align: center;
  text-transform: uppercase;

  ${mediaMax('mobile')} {
    font-size: ${calculateMobileResponsiveSize(36)};
    color: #581f0c;
  }
`

export const Li = styled.li`
  color: #581f0c80;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: ${calculateResponsiveSize(27)};
  & .bird {
    width: ${calculateResponsiveSize(38)};
    opacity: 0;
  }
  &:hover .bird {
    opacity: 1;
  }
  ${mediaMax('mobile')} {
    color: #581f0c;

    gap: ${calculateMobileResponsiveSize(0)};
    &:hover .bird {
      opacity: 0;
    }
    & .lf-player-container {
      display: none;
    }
  }
`

export const Primary = styled.ul`
  display: inline-flex;
  flex-direction: column;
  justify-content: center;
  gap: ${calculateResponsiveSize(12.5)};
  margin-left: -${calculateResponsiveSize(65)};
  ${mediaMax('mobile')} {
    gap: ${calculateMobileResponsiveSize(27)};
    margin-left: 0;
  }
`

export const Wrapper = styled.div`
  z-index: 102;

  height: 0dvh;
  width: 100vw;
  position: fixed;
  overflow: hidden;

  top: 0;
  right: 0;

  transition: 0.7s 0.7s;

  .open-menu & {
    height: 100dvh;
    width: 100vw;
    transition: 0.7s 0s;
  }

  ${mediaMax('mobile')} {
  }
`
export const Overflow = styled.div`
  z-index: 101;
  transition: 1s;

  height: 0vw;
  width: 0vw;
  position: fixed;
  border-radius: 50%;
  transform: translate(50%, -50%);
  top: ${calculateResponsiveSize(20)};
  right: ${calculateResponsiveSize(20)};
  background: var(--flower);
  .open-menu & {
    height: 300vw;
    width: 300vw;
  }
  ${mediaMax('mobile')} {
    top: ${calculateMobileResponsiveSize(20)};
    right: ${calculateMobileResponsiveSize(30)};
    .open-menu & {
      height: 220dvh;
      width: 220dvh;
    }
  }
`

export const Links = styled.div`
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  gap: ${calculateResponsiveSize(6)};

  ${mediaMax('mobile')} {
    gap: 10px;
  }
`

export const CloseButton = styled.button`
  -webkit-mask-image: url(${CloseIcon});
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  -webkit-mask-size: contain;

  mask-image: url(${CloseIcon});
  mask-repeat: no-repeat;
  mask-position: center;
  mask-size: contain;

  border: none;

  width: ${calculateResponsiveSize(12)};
  height: ${calculateResponsiveSize(12)};
  display: block;
  cursor: pointer;
  background: #581f0c;

  position: absolute;
  right: ${calculateResponsiveSize(20)};
  top: ${calculateResponsiveSize(14)};

  &:hover {
    background: var(--beige);
  }

  ${mediaMax('mobile')} {
    width: ${calculateMobileResponsiveSize(12)};
    height: ${calculateMobileResponsiveSize(12)};

    top: 3.5059vw;
    right: ${calculateMobileResponsiveSize(30)};
    &:hover {
      background: var(--brick);
    }
  }
`
export const Apply = styled.a`
  border: 1px solid var(--brick);
  font-family: Mr Eaves XL Mod OT;
  font-weight: 700;
  font-size: ${calculateResponsiveSize(15)};
  leading-trim: Cap height;
  line-height: 120%;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  padding: ${calculateResponsiveSize(6)} ${calculateResponsiveSize(38)}
    ${calculateResponsiveSize(6)} ${calculateResponsiveSize(12)};
  background: url(${ArrowIcon}) no-repeat
    calc(100% - ${calculateResponsiveSize(12)}) center;
  background-size: ${calculateResponsiveSize(16)} ${calculateResponsiveSize(9)};

  &:hover {
    border: 1px solid var(--beige);
    color: var(--beige);
    background: url(${ArrowWIcon}) no-repeat
      calc(100% - ${calculateResponsiveSize(12)}) center;
    background-size: ${calculateResponsiveSize(16)}
      ${calculateResponsiveSize(9)};
  }
  ${mediaMax('mobile')} {
    font-size: ${calculateMobileResponsiveSize(16)};
    line-height: ${calculateMobileResponsiveSize(18)};
    letter-spacing: 0.1em;
    padding: ${calculateMobileResponsiveSize(6)}
      ${calculateMobileResponsiveSize(38)} ${calculateMobileResponsiveSize(6)}
      ${calculateMobileResponsiveSize(12)};
    background: url(${ArrowIcon}) no-repeat
      calc(100% - ${calculateMobileResponsiveSize(12)}) center;
    background-size: ${calculateMobileResponsiveSize(16)}
      ${calculateMobileResponsiveSize(9)};
    &:hover {
      color: var(--brick);
      border: 1px solid var(--brick);
    }
  }
`

export const Insta = styled.a`
  width: ${calculateResponsiveSize(22)};
  height: ${calculateResponsiveSize(22)};
  -webkit-mask: url(${InstaIcon}) no-repeat;
  -webkit-mask-size: contain;
  background: var(--brick);
  display: flex;
  flex: 0 0 auto;
  position: absolute;
  right: ${calculateResponsiveSize(42)};
  bottom: ${calculateResponsiveSize(28)};
  &:hover {
    background: var(--beige);
  }

  ${mediaMax('mobile')} {
    display: none;
  }
`
